import { version } from "../package.json";
import { versionLabel } from "./version-label";

export function App() {
	return <h1 id="title">{versionLabel(version)}</h1>;
}
